<template>
    <div class="tsa-w-steps">
        <ul v-for="(item, index) in list" :key="index">
            <li :class="index + 1 < active ? 'activeIcon' : index + 1 === active ? 'equalIcon' : ''">
                <span>{{ index + 1}}</span>
                <i class="el-icon-check"></i>
            </li>
            <li :class="index + 1 < active ? 'activeText' : index + 1 === active ? 'equalText' : ''">{{ item }}</li>
            <li v-if="index < list.length-1"></li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'tsa-steps',
    props: {
        active: {
            type: Number,
            default: 0
        },
        list: {
            type: Array,
            default: () => {
                return [ '基础信息填写', '创作过程认证', '版权认证证书生成' ]
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .tsa-w-steps {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding:12px;
        ul {
            display: flex;
            align-items: center;
            margin-bottom: 0;
            li {
                color: #999;
                font-weight: bold;
                &:first-child {
                    flex-shrink: 0;
                    margin-right:4px;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    border-radius: 50%;
                    overflow: hidden;
                    border: 1px solid #999;
                    background: #fff;
                    color: #999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    span {
                        display: block;                        
                    }
                    i {
                        display: none;
                    }
                }
                &:nth-child(2) {
                    margin-right: 0;
                    font-size: 12px;
                }
                &.activeIcon {
                    color: #fff;
                    border: 1px solid #7FDC68;
                    background: #7FDC68;
                    span {
                        display: none!important;
                    }
                    i {
                        display: block!important;
                    }
                }
                &.equalIcon {
                    color: #fff!important;
                    background: #1F5EFF !important;
                    border: 1px solid #1F5EFF !important;
                    span {
                        display: block!important;
                    }
                    i {
                        display: none!important;
                    }
                }
                &.activeText{
                    font-weight: bold;
                    color: #000;
                }
                &.equalText {
                    font-weight: bold;
                    color: #1F5EFF;
                }
            }
            .activeLine {
                background: #1F5EFF;
            }
        }
    }
</style>